/* eslint-disable no-restricted-syntax */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/require-default-props */
import { ActionIcon, Group, Paper, Space, Text, ThemeIcon, Tooltip } from '@mantine/core';
import { useModals } from '@mantine/modals';
import {
  IconCalendarEvent,
  IconCheck,
  IconEye,
  IconId,
  IconScale,
  IconShare,
  IconX,
  IconZoomMoney,
} from '@tabler/icons-react';
import { Table, Tabs } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import PageSection from '../../../../../../components/core/PageSection/PageSection';
import ProfileCardLink from '../../../../../../components/core/ProfileCardLink/ProfileCardLink';
import RecurrenceView from '../../../../../../components/core/Recurrence/RecurrenceView';
import { EntityTypeType, UnitOfMeasureType } from '../../../../../../models/core/cache.type';
import {
  ProposalServiceQuotationType,
  ProposalServiceType,
  ProposalType,
} from '../../../../../../models/core/proposals.type';
import theme from '../../../../../../theme';
import { montarRecorrenciaString } from '../../../../../../utils/business.utils';
import { Feature } from '../../../../../../utils/constants.utils';
import { newGuid } from '../../../../../../utils/helper.utils';
import ServiceQuotationEditor from '../../../ProposalAddEdit/components/components/ServiceFormView/components/ServiceQuotationEditor';
import ServiceGeneralView from './ServiceView/ServiceGeneralView';

type ViewProps = {
  data: ProposalServiceType[];
  proposal: ProposalType;
  referenceData?: {
    entityTypeData?: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
  };
  zIndex: number;
};

export default function ServiceView(props: ViewProps) {
  const modals = useModals();

  const buildSharedResidues = (row: ProposalServiceType) => {
    const sharedResidues: string[] = [];

    for (const residuo of props.proposal.residuos) {
      if (
        residuo.planos
          .filter((x) => x.primario)
          .map((y) => y.acondicionamentos)
          .flat()
          .findIndex((z) => z.idPropostaServico === row.idPropostaServico) > -1
      ) {
        sharedResidues.push(residuo.residuoCliente);
      }
    }

    return sharedResidues;
  };

  const openServiceModal = (
    row: ProposalServiceType,
    initialQuotationItem?: ProposalServiceQuotationType | null,
    initialQuotationTab?: string
  ) => {
    const tabs = [
      {
        key: 'Geral',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
              <IconId size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
              Geral
            </Text>
          </Group>
        ),
        children: <ServiceGeneralView data={row} />,
        forceRender: true,
      },
      {
        key: 'Recorrencia',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
              <IconCalendarEvent size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
              Recorrência
            </Text>
          </Group>
        ),
        children: (
          <RecurrenceView
            title="Recorrência"
            description="Eventos personalizados a serem gerados para este serviço."
            color={Feature.Home.Proposal.color}
            data={row.recorrencia}
          />
        ),
        forceRender: true,
      },
      {
        key: 'Cotacoes',
        label: (
          <Group>
            <ThemeIcon color={Feature.Home.Proposal.color} variant="outline">
              <IconZoomMoney size={18} />
            </ThemeIcon>
            <Text size="md" color={Feature.Home.Proposal.color} style={{ fontWeight: 500 }}>
              Cotações
            </Text>
          </Group>
        ),
        children: (
          <Paper shadow="xs" p="md" withBorder>
            <ServiceQuotationEditor
              data={row}
              sharedResidues={buildSharedResidues(row)}
              referenceData={props.referenceData}
              zIndex={props.zIndex + 1}
              initialQuotationItem={initialQuotationItem || null}
              initialQuotationTab={(initialQuotationTab as 'Cotacao' | 'Tolerancias') || 'Cotacao'}
            />
          </Paper>
        ),
        forceRender: true,
      },
    ];

    modals.openModal({
      title: `Serviço - Visualizar (#${row.idPropostaServico})`,
      size: '70%',
      closeOnClickOutside: false,
      children: (
        <Paper shadow="xs" p="md" withBorder>
          <Tabs items={tabs} defaultActiveKey="Geral" />
        </Paper>
      ),
    });
  };

  // const buildClientPrice = (row: ProposalServiceType) => (
  //   <Stack gap={2}>
  //     <Text size="sm">
  //       {row.precificacao?.preco ? formatCurrency(row.precificacao.preco) : '-'}
  //       {' | '}
  //       {row.precificacao?.quantidade} {row.precificacao?.quantidadeUnidadeMedida} /{' '}
  //       {row.precificacao?.frequenciaUnidadeMedida}
  //     </Text>
  //   </Stack>
  // );

  // const buildPrimaryQuotation = (row: ProposalServiceType) => {
  //   const primaryQuotation = row.cotacoes.find((x) => x.primario);
  //   if (!primaryQuotation) {
  //     return (
  //       <Text size="sm" c="dimmed">
  //         Não definida
  //       </Text>
  //     );
  //   }

  //   return (
  //     <Stack gap={2}>
  //       <Text size="sm" fw={600}>
  //         {primaryQuotation.fornecedorNomeFantasia ||
  //           primaryQuotation.fornecedorRazaoSocial ||
  //           primaryQuotation.fornecedorNome ||
  //           '-'}
  //       </Text>
  //       <Text size="sm">
  //         {primaryQuotation.preco ? formatCurrency(primaryQuotation.preco) : '-'}
  //         {' | '}
  //         {primaryQuotation.quantidade} Unidade(s) / {primaryQuotation.frequenciaUnidadeMedida2}
  //       </Text>
  //     </Stack>
  //   );
  // };

  const columns: ColumnsType<any> = [
    {
      title: 'Serviço',
      key: 'servico',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => a.servico.localeCompare(b.servico),
      render: (row: ProposalServiceType) => (
        <ProfileCardLink
          id={row.idServico.toString()}
          name={row.servico}
          nameSize="sm"
          description={row.servicoDescricao}
          descriptionSize="xs"
          linkPrefix="services"
          showLink={false}
        />
      ),
    },
    {
      title: 'Item',
      key: 'item',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => {
        const aItem = a.residuoAcondicionamento || a.residuoEquipamento || '-';
        const bItem = b.residuoAcondicionamento || b.residuoEquipamento || '-';
        return aItem.localeCompare(bItem);
      },
      render: (row: ProposalServiceType) => {
        if (row.idResiduoAcondicionamento) {
          return (
            <ProfileCardLink
              id={(row.idResiduoAcondicionamento || '').toString()}
              name={row.residuoAcondicionamento || '-'}
              nameSize="sm"
              description={row.residuoAcondicionamentoDescricao}
              descriptionSize="xs"
              linkPrefix="packaging"
              showLink
            />
          );
        }
        if (row.idResiduoEquipamento) {
          return (
            <ProfileCardLink
              id={(row.idResiduoEquipamento || '').toString()}
              name={row.residuoEquipamento || '-'}
              nameSize="sm"
              description={row.residuoEquipamentoDescricao}
              descriptionSize="xs"
              linkPrefix="equipment"
              showLink
            />
          );
        }
        return (
          <ProfileCardLink
            id={newGuid.toString()}
            name="Fornecedor"
            nameSize="sm"
            description={null}
            descriptionSize="xs"
            showLink={false}
          />
        );
      },
    },
    {
      title: 'Quantidade',
      key: 'quantidade',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => a.quantidade - b.quantidade,
      render: (row: ProposalServiceType) => <div>{row.quantidade.toString()}</div>,
    },
    {
      title: 'Frequência',
      key: 'frequencia',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => {
        const aIsService = !(a.idResiduoAcondicionamento || a.idResiduoEquipamento);
        const bIsService = !(b.idResiduoAcondicionamento || b.idResiduoEquipamento);
        const aItem = `${aIsService ? `${a.frequencia} ` : ''}${a.frequenciaUnidadeMedida1} / ${
          a.frequenciaUnidadeMedida2
        }`;
        const bItem = `${bIsService ? `${b.frequencia} ` : ''}${b.frequenciaUnidadeMedida1} / ${
          b.frequenciaUnidadeMedida2
        }`;
        return aItem.localeCompare(bItem);
      },
      render: (row: ProposalServiceType) => {
        const isService = !(row.idResiduoAcondicionamento || row.idResiduoEquipamento);
        return (
          <div>{`${isService ? `${row.frequencia} ` : ''}${row.frequenciaUnidadeMedida1} / ${
            row.frequenciaUnidadeMedida2
          }`}</div>
        );
      },
    },
    {
      title: 'Recorrência',
      key: 'recorrencia',
      render: (row: ProposalServiceType) => {
        const recorrencia = montarRecorrenciaString(row.recorrencia);
        if (!recorrencia) {
          return '-';
        }
        return (
          <div>
            <div>{recorrencia.str1}</div>
            {recorrencia.str2 ? <div>{recorrencia.str2}</div> : <></>}
          </div>
        );
      },
    },
    // {
    //   title: 'Preço',
    //   key: 'preco',
    //   sorter: (a: ProposalServiceType, b: ProposalServiceType) =>
    //     (a.precificacao?.preco || 0) - (b.precificacao?.preco || 0),
    //   render: (row: ProposalServiceType) => buildClientPrice(row),
    // },
    // {
    //   title: 'Cotação Primária',
    //   key: 'cotacaoPrimaria',
    //   sorter: (a: ProposalServiceType, b: ProposalServiceType) =>
    //     (a.cotacoes.find((x) => x.primario)?.preco || 0) - (b.cotacoes.find((x) => x.primario)?.preco || 0),
    //   render: (row: ProposalServiceType) => buildPrimaryQuotation(row),
    // },
    {
      title: 'Cotações',
      key: 'cotacoes',
      sorter: (a: ProposalServiceType, b: ProposalServiceType) => a.cotacoes.length - b.cotacoes.length,
      render: (row: ProposalServiceType) => {
        const toleranceCount = row.cotacoes.reduce((acc, item) => acc + (item.tolerancias?.length || 0), 0);
        return (
          <Group gap="xs">
            <div>{row.cotacoes.length || '-'}</div>
            <div>
              {row.cotacoes.some((x) => x.primario) ? <IconCheck color="green" /> : <IconX color="red" />}
            </div>
            <Group gap={4}>
              <IconScale size={16} />
              <div>{toleranceCount}</div>
            </Group>
            {row.compartilhado && (
              <div>
                <IconShare size={16} />
              </div>
            )}
          </Group>
        );
      },
    },
    {
      title: 'Ações',
      width: '100px',
      render: (row: ProposalServiceType) => (
        <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Visualizar">
          <ActionIcon
            size="sm"
            radius="sm"
            color="primary"
            style={{ borderColor: theme?.colors?.primary?.[6] }}
            variant="outline"
            onClick={() => {
              openServiceModal(row);
            }}
          >
            <IconEye size={15} color={theme?.colors?.primary?.[6]} />
          </ActionIcon>
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <PageSection
        size="lg"
        color={Feature.Home.Proposal.color}
        label="Serviços"
        text="Todos os serviços requisitados pelo cliente juntamente com suas cotações."
      />
      <Space h="xs" />

      <Table
        showSorterTooltip={false}
        dataSource={props.data}
        columns={columns}
        rowKey={(item: ProposalServiceType) => item.idPropostaServico || 0}
        expandable={{
          rowExpandable: (row) => row.cotacoes.length > 0,
          expandedRowRender: (row) => (
            <ServiceQuotationEditor
              data={row}
              sharedResidues={buildSharedResidues(row)}
              referenceData={props.referenceData}
              zIndex={props.zIndex + 2}
            />
          ),
        }}
        pagination={{
          pageSizeOptions: [10, 25, 50],
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
        }}
      />
    </div>
  );
}
